import {
  GridItem,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface SizingPageSectionProps
  extends ComponentPropsWithoutRef<'section'> {
  readonly heading: {
    before?: ReactNode;
    content: MessageKey;
    after?: ReactNode;
  };
}

const SizingPageSection = ({
  children,
  heading,
  ...props
}: SizingPageSectionProps): JSX.Element => {
  const t = useTranslations();

  return (
    <section {...props} className={cx('py-12 last:pb-24', props.className)}>
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main', lg: 12 }} colStart={{ sm: 'main' }}>
          {heading.before}
          <TypographyV3 className="leading-tight" Element="h2" variant="h3">
            {t.rich(heading.content)}
          </TypographyV3>
          {heading.after}
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', lg: 14 }}>
          <TypographyRhythm>{children}</TypographyRhythm>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default SizingPageSection;
